import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { OnlyNumberDirective } from '../../directives/only-number.directive';
import { ContactUsService } from '../../services/contact-us.service';
import { IQuestion } from '../../../core/models/question.model';
import { QUESTION_CONTACT } from '../../../core/constants/question-contact';
import { finalize } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CommonService } from '../../services/common.service';
import { AlertComponent } from '../alert/alert.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    OnlyNumberDirective,
    CommonModule
  ]
})
export class ContactUsComponent implements OnInit {
  formContact: FormGroup = new FormGroup({});
  private contactUsService = inject(ContactUsService);
  private commonService = inject(CommonService);
  private dialog = inject(MatDialog);

  constructor() { }

  ngOnInit() {
    this.setForm();
  }

  setForm() {
    this.formContact = new FormGroup({
      name: new FormControl('', [Validators.required]),
      codePhone: new FormControl('', [Validators.required]),
      phone: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      message: new FormControl('', [Validators.required])
    });
  }

  sendMessage() {
    if (!this.formContact.valid) {
      return
    }
    let form: IQuestion[] = [];
    QUESTION_CONTACT.forEach((item) => {
      if (this.formContact?.value[item.value]) {
        form.push({
          question: item.question,
          answer: item.value === 'phone' ? (this.formContact?.value.codePhone + this.formContact?.value.phone) : this.formContact?.value[item.value]
        });
      }
    });
    this.commonService.loading.next(true);
    const payload = {
      preguntas: [...form]
    }
    this.contactUsService.sendMessage(payload).pipe(
      finalize(() => {
        this.commonService.loading.next(false);
        this.formContact.reset();
        this.setForm();
        this.dialog.open(AlertComponent,
          {
            width: '536px',
            data: {
              buttonText: 'Entendido'
            }
          }
        );
      })
    ).subscribe((response) => {
      console.log(response);
    });
  }

}
